﻿import { Typography } from '@equinor/eds-core-react'
import { wifi_off } from '@equinor/eds-icons'
import { ReactElement } from 'react'
import { useAtomValue } from 'jotai'
import { isOfflineAtom } from '@/core/store/globalStore'
import styled from 'styled-components'
import { baseFont } from '@/styles'
import { InfoBanner } from './InfoBanner'

export function SocketErrorDisplayBanner(): ReactElement {
    const displayOfflineBanner = useAtomValue(isOfflineAtom)

    if (!displayOfflineBanner) {
        return <></>
    }
    return (
        <InfoBanner icon={wifi_off} placement="global">
            <OfflineMessage>
                You are offline. You can still make changes, and they will be saved once you are back online.
            </OfflineMessage>
        </InfoBanner>
    )
}

const OfflineMessage = styled(Typography)`
    ${baseFont}
    color: inherit;
`
